// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__lJmok","container":"styles_container__MAYTo","content":"styles_content__PhfIp","title":"styles_title__48ac_","blueColor":"styles_blueColor__68c6O"};